var React = require('react');

function SortAscIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"16","height":"16","fill":"white","key":0}),React.createElement("path",{"d":"M8 12V4M8 4L5 7M8 4L11 7","stroke":"#0088BF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

SortAscIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = SortAscIcon;

SortAscIcon.default = SortAscIcon;
